import { useState } from "react";
import { useMount } from "react-use";

export const useGoogleDriveListener = () => {
  const [open, setOpen] = useState(false);
  useMount(() => {
    const listener = (e) => {
      if (typeof e.detail === "boolean") {
        setOpen(e.detail);
      }
    };
    document.addEventListener("google-drive-picker", listener);

    return () => document.removeEventListener("google-drive-picker", listener);
  });

  return open;
};
